function setAttributes(el, attrs) {
    for(var key in attrs) {
      el.setAttribute(key, attrs[key]);
    }
}

const uniqueElementsBy = (arr, fn) =>
  arr.reduce((acc, v) => {
    if (!acc.some(x => fn(v, x))) acc.push(v);
    return acc;
}, []);

const PDP = {
    state: {
        product: null,
        products: [],
    },
    carousels() {
        $('.main-carousel').on('ready.flickity', function(){
            const $viewport = document.querySelector('.main-carousel .flickity-viewport')

            const height = $viewport.style.height;
            console.log('Main Flickity Ready', { height });

            document.querySelector('.carousel-nav').style.maxHeight = height;
        });

        var $carousel = $('.main-carousel').flickity();

        this.$carousel = $carousel;

        
        var $carouselNav = $('.carousel-nav');
        var $carouselNavCells = $carouselNav.find('.carousel-cell');

        $carouselNav.on( 'click', '.carousel-cell', function( event ) {
            var index = $( event.currentTarget ).index();
            $carousel.flickity( 'select', index );

            console.log('Carosel Nav Click', {$carousel, index});
        });

        $('.thumbnail-wrapper').slick({
            vertical: true,
            slidesToShow: 5,
            arrows: true,
            dots: false,
            infinite: false,
        });
    },
    checkInfiniteOptions() {
        const { product } = this.state;
        const { tags, type } = this.state.product;

        let data;

        try {
            data = JSON.parse(document.querySelector('script[data-infinite-options]').innerHTML)
        } catch (error) {
            return;
        }

        const qualifiedOptions = data.filter((option) => {
            const { equals, type } = option;

            if(type === 'tags') {
                return product.tags.includes(equals);
            }

            return product[type] === equals;
        });

        qualifiedOptions.forEach((option, index) => {
            const { default_value, label, values } = option;
            const $wrapper = document.createElement('div');
            $wrapper.classList.add('extra-selector-wrapper');

            const select = `
                <label for="${label}-selector">${label}</label>
                <select name="properties[${label}]" id="${label}-selector" data-index="${index}">
                ${[...values].map((value) => {
                    return `
                        <option value="${value}" ${value === default_value ? 'selected="selected"' : ''}>${value}</option>
                    `
                })}
                </select>
            `;

            $wrapper.innerHTML = select;

            document.querySelector('.form-extra-dropdowns').appendChild($wrapper);
        });

        function infiniteChangeHandler(event) {
            const $select = event.target;
            const value = $select.value;
            const index = $select.getAttribute('data-index');

            const option = [...qualifiedOptions].find((option, optionIndex) => optionIndex === Number(index));

            if(value !== option.default_value) {
                document.querySelector('.form-extras-wrapper .disclaimers').textContent = option.disclaimer;
            } else {
                const currentDisclaimer = document.querySelector('.form-extras-wrapper .disclaimers').textContent;

                document.querySelector('.form-extras-wrapper .disclaimers').textContent = (currentDisclaimer  === option.disclaimer) ? '' : document.querySelector('.form-extras-wrapper .disclaimers').textContent;
            }
            console.log('Infinite Change Handler', $select, index, option);
        }

        const $selects = document.querySelectorAll('.form-extra-dropdowns select');

        [...$selects].forEach(function($select) {
            $select.addEventListener('change', infiniteChangeHandler);
        })
        console.log('Check Infinite Options', tags, type, data, { qualifiedOptions });
    },
    checkAddons() {
        const { tags } = this.state.product;


         if(!tags) return;
        const chainAddonTag = [...tags].find((tag) => {
            return /add on:/ig.test(tag)&& /chain/ig.test(tag);
        });

        if(chainAddonTag) this.chainAddon(chainAddonTag);

        console.log('Check Addons', this.state.product, chainAddonTag, tags);
    },
    async chainAddon(tag) {
        const chainProductHandle = 'add-on-chain-length';
        const chainProduct = await this.fetchProduct(chainProductHandle);

        if(!chainProduct) return;

        console.log('Chain Product', chainProduct, tag);

        const tagLengths = tag.match(/[0-9]/gi);

        const matchedPhrase = tag.match(/length:(.*)type/gi);
        const matchedTypes = tag.match(/type:(.*)$/gi);
        const chainLengths = (matchedPhrase[0]) ? matchedPhrase[0].replace(/(length:|type)/gi,'').trim().split('|') : null;
        const chainTypes = (matchedTypes[0]) ? matchedTypes[0].replace(/type:/gi, '').replace(/lead-time/ig, '').trim().split('|') : null;

        const leadTime =/lead-time/ig.test(tag);
        
        console.log('CHAIN TYPE TAG', chainTypes);

        const typePosition = chainProduct.options.findIndex((option) => /type/ig.test(option.name));
        const lengthPosition = chainProduct.options.findIndex((option) => /inches/gi.test(option.name));

        const qualifiedVariants = chainProduct.variants.filter((variant) => {
            const option = variant[`option${lengthPosition+1}`];
            const typeOption = variant[`option${typePosition+1}`];

            return chainLengths.find((length) => option.indexOf(length) > -1) && chainTypes.find((type) => typeOption.indexOf(type) > -1);
            return tagLengths.find((length) => option.indexOf(length) > -1);
        });

        console.log('Qualified Chains', qualifiedVariants);
        


        const $wrapper = document.createElement('div');
        $wrapper.classList.add('extra-selector-wrapper');
        $wrapper.classList.add('relative');
        
        const select = `
            <label for="chain-length-selector">Chain</label>
            <select name="id" id="chain-length-selector" >
              <option value="_none">No Chain</option>
                ${[...qualifiedVariants].map((variant) => {
                    return `
                        <option value="${variant.id}">${variant.title.replace(/\//gi, '')}</option>
                    `
                }).join('')}
            </select>
        `;

        if(leadTime) {
            $wrapper.setAttribute('data-lead', "4-6 week lead time.");
        }

        $wrapper.innerHTML = select;
        $wrapper.querySelector('select').addEventListener('change', function(event) {
            console.log('Select Change', event.target.value);
            const value = event.target.value;

            if(value === '_none') {
                event.target.parentElement.classList.remove('warning');
            } else {
                event.target.parentElement.classList.add('warning');
            }

        });
        

        document.querySelector('.form-extra-dropdowns').appendChild($wrapper);

        console.log('Initialize Chain Addon', {chainProduct, tag, lengthPosition, tagLengths, qualifiedVariants});
    },
    descriptionHandler() {
        const $self = this;
        const $tabsWrapper = document.querySelector('#product-add .tabs-wrapper');

        if(!$tabsWrapper) return;
        const $tabList = $tabsWrapper.querySelector('.tablist')
        const $descriptionTable = $tabsWrapper.querySelector('#description-panel table');
        let $ulWrapper = null;

        if(!$descriptionTable) return;

        const tabs = ['Description', 'Details', 'Care'];

        const $rows = $descriptionTable.querySelectorAll('tr');

        const content = [...$rows].reduce(function(description, $row, index) {
            const $td = $row.querySelector('td');

            if(index === 0 && $td.querySelector('ul')) {
                console.log('Found UL!', $td.querySelector('ul'));
                $ulWrapper = document.createElement('div');
                $ulWrapper.classList.add('ul-wrapper');
                $ulWrapper.appendChild($td.querySelector('ul'));
            }

            description[tabs[index]] = $td.innerHTML;

 
            return description;
        }, {});

        function createTabButton(label) {
            const $btn = document.createElement('button');

            const attributes = {
                role: 'tab',
                class: 'tab-control',
                'aria-selected': 'false',
                type: 'button',
                'aria-controls': `${$self.handlizeString(label)}-panel`,
                id: `${$self.handlizeString(label)}-tab`,
            }

            setAttributes($btn, attributes);
            $btn.textContent = label;

            $tabList.appendChild($btn);

            return $btn;
        }

        function createTabPanel(label) {
            const $panel = document.createElement('div');

            const attributes = {
                role: 'tabpanel',
                tabindex: '0',
                'aria-labelledby': `${$self.handlizeString(label)}-tab`,
                id:  `${$self.handlizeString(label)}-panel`,
                class: 'tabpanel'
            };

            setAttributes($panel, attributes);

            $tabsWrapper.appendChild($panel);

            return $panel;
        }

        [...tabs].forEach(function(tabKey) {
            const safeKey = $self.handlizeString(tabKey);
            let $tabBtn = document.querySelector(`.tab-control#${safeKey}-tab`);
            let $tabPanel = document.querySelector(`.tabpanel#${safeKey}-panel`);

            if(!$tabBtn) {
                $tabBtn = createTabButton(tabKey);
            }
            
            if(!$tabPanel) {
                $tabPanel = createTabPanel(tabKey);
            }

            $tabPanel.innerHTML = content[tabKey];
            console.log('$TabBtn', {$tabBtn, $tabPanel});
        });

        // Tab Selection
        const $tabs = $tabsWrapper.querySelectorAll('.tab-control')
        const $tabPanels = $tabsWrapper.querySelectorAll('.tabpanel');

        function selectPreviousTab() {
            var activeTab = document.querySelector('.tab-control[aria-selected="true"]');
            var activeTabIndex = Array.prototype.slice.call($tabs).indexOf(activeTab);
            
            // Select the previous tab, wrapping to last tab if needed
            if(activeTabIndex > 0) {
              selectTab(activeTabIndex - 1);
            } else {
              selectTab($tabs.length - 1);
            }
        }

        
        function selectNextTab() {
            var activeTab = document.querySelector('.tab-control[aria-selected="true"]');
            var activeTabIndex = Array.prototype.slice.call($tabs).indexOf(activeTab);
            
            // Select the next tab, wrapping to the first tab if needed 
            if(activeTabIndex < $tabs.length - 1) {
              selectTab(activeTabIndex + 1);
            } else {
              selectTab(0);
            }
        }

        function selectFirstTab() {
          selectTab(0);
        }
        
        function selectLastTab() {
          selectTab($tabs.length - 1);
        }

        function selectTab(index) {
          // Deactivate all tabs
          $tabs.forEach(function(tab) {
            tab.setAttribute('aria-selected', false);
            tab.setAttribute('tabindex', -1);
          });
          
          // Activate only the requested tab, and set focus to it
          $tabs[index].setAttribute('aria-selected', true);
          $tabs[index].setAttribute('tabindex', 0);
          $tabs[index].focus();
          
          // Hide all tabpanels
          $tabPanels.forEach(function(tabpanel) {
            tabpanel.classList.remove('is-visible');
          });
          
          // Show only the tabpanel for the requested tab
          var nextTabpanel = document.querySelector('#' + $tabs[index].getAttribute('aria-controls'));

          console.log('Find Tab Panel', $tabs, index, $tabs[index]);

          nextTabpanel.classList.add('is-visible');
        }


        // Now Event Listeners
        // Select previous/next tabs using Left and Right arrow keys
        $tabList.addEventListener('keydown', function(e) {
            switch(e.key) {
            case 'ArrowLeft':
                selectPreviousTab();
                break;
                
            case 'ArrowRight':
                selectNextTab();
                break;

            case 'Home':  // optional
                e.preventDefault();  // prevent page scroll
                selectFirstTab();
                break;
                
            case 'End':  // optional
                e.preventDefault();  // prevent page scroll
                selectLastTab();
                break;
            }
        });

        $tabs.forEach(function(tab) {
            tab.addEventListener('click', function(e) {
              let nextTabIndex = Array.prototype.slice.call($tabs).indexOf(e.target);
              selectTab(nextTabIndex);
            });
        });

        if($ulWrapper) {
            $tabsWrapper.appendChild($ulWrapper);
        }


        console.log('Description Table', $descriptionTable, content);

    },
    fetchProduct(handle) {
        return fetch(`/products/${handle}.js`).then((res) => res.json())
    },
    handlizeString(str) {
        return str.replace(/\s+/g, '-').toLowerCase();
    },
    async fetchOtherProducts(product) {
        const tags = product.tags;
        const groupTag = tags.find((tag) => /group-/ig.test(tag));
        const byHandle = await fetch(`/search?view=json&q=${product.handle}`).then((res) => res.json());
        const byTitle = await fetch(`/search?view=json&q=${product.title}`).then((res) => res.json());
        const byGroupTag = await fetch(`/search?view=json&q=${groupTag}`).then((res) => res.json());

        const final = uniqueElementsBy(
            [...byHandle.results.concat([...byTitle.results, ...byGroupTag.results])],
            (a,b) => a.id === b.id
        );


        if(!groupTag) return final;


        const group = final.filter((item) => item.tags.includes(groupTag));


        return group;
    },
    buildDropdown({
        container = null,
		label, 
		values }) {
        const $wrapper = document.createElement('div');
        const currentProductLabel = this.state.product.tags.find((tag) => /stone:/ig.test(tag)) || this.state.product.title;

        $wrapper.classList.add('extra-selector-wrapper');

        console.log('Build Dropdowns', this.state.product, {values, currentProductLabel});

        values = values.sort((a,b) => {
            const aValue = a.override || a.value || a;
            const bValue = b.override || b.value || b;

            return aValue.localeCompare(bValue);
        });

        $wrapper.innerHTML = `
            <label for="${label}-selector">${label}</label>
            <select name="${label}" id="${label}-selector">
              ${[...values].map((value) => { 
                  return `
                    <option value="${value.override || value.value || value}" ${(value.value || value) === currentProductLabel ? 'selected' : ''}>${value.value || value}</option>
                  `
              }).join('')}
            </select>
        `;

          if(container) {
			const $second = $wrapper.cloneNode(true);
            $second.querySelector('select').addEventListener('change', this.handleOtherColorsChange.bind(this));
            container.appendChild($second);
          }
        document.querySelector('.form-extra-dropdowns').appendChild($wrapper);
        $wrapper.querySelector('select').addEventListener('change', this.handleOtherColorsChange.bind(this));
    },
    handleOtherColorsChange(event) {
        const selection = event.target.value;
        const newProduct = this.state.products.find((item) => item.handle == selection);
        console.log('Other Colors', event, this.state, { newProduct });

        if(newProduct) {
            window.location = `/products/${newProduct.handle}`;
        }
        
    },
    async otherColorsDetection() {
        console.log('other colors', this.state.product);
        const others = await this.fetchOtherProducts(this.state.product);

        this.state.products = this.state.products.concat(others);

        console.log('OTHERS!', others);
        const selectAttributes = {
            label: 'Select Stone',
			container: document.querySelector('.pdp-content-wrapper .product-color'), 
            values: [...others].filter((product) => Boolean(product.tags)).map((product) => {
               const color = [...product.tags].reduce((color, tag) => {
                   if(/stone:/ig.test(tag)) {
                       const [key, stone] = tag.split(':');
                       return stone;
                   }

                   return color;
               }, null);
               return {
                   override: product.handle,
                   value: color || product.title
               };
            }),
        };

        if(selectAttributes.values.length > 1) {
            this.buildDropdown(selectAttributes);
        } else {
            selectAttributes.container.style.display = 'none'; 
        }
        console.log('Others', others);
    },
    productJSON() { 
        try {
            const $source = document.getElementById('product-source');

            this.state.product = JSON.parse($source.innerHTML);
        } catch (error) {
            this.state.product = {}
        }
    },
    nostoHandlers() {
        const $nostoElements = document.querySelectorAll('.nosto_element.new-pdp');

        function startFeed($nosto) {
            const $block = $nosto.querySelector('.nosto-block');

            if(!$block) return setTimeout(function() {
                startFeed($nosto);
            }, 750);

            $nosto.classList.add('ready');
            const $list = $nosto.querySelector('.nosto-list') || $nosto;

            console.log('Start List Feed', $list, $list.classList.contains('slick-initialized'));
            if($list.classList.contains('slick-initialized')) return;

            const $header = $nosto.querySelector('.nosto-header .arrows-wrapper');

            $($list).slick({
                slidesToShow: 4,
                appendArrows: $header,
                dots: true,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }
                ]
            })
        }

        [...$nostoElements].forEach(function($nosto) {
            startFeed($nosto);
        });

        $('.related-feed').slick({
            slidesToShow: 4,
            dots: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ]
        })

        console.log('Nosto Handlers', $nostoElements);
    },
    priceUponRequest() {
        const tags = this.state.product.tags;

        if(!tags.includes('price upon request')) return;

        const $modal = document.querySelector('#price-request-modal');

        document.querySelector('#request-pricing').addEventListener('click', function(event) {
            console.log('Open price request'); 
            $modal.classList.add('showing');
        });

        document.querySelector('#close-price-request').addEventListener('click', function() {
            $modal.classList.remove('showing');
        });
        console.log('Price Upon', this.state.product);
    },
    wishlistHandler() {
        const $self = this;

        if(!window.SwymCallbacks){
          window.SwymCallbacks = [];
        }

        function wishlistStart() {

            window._swat.fetchWrtEventTypeET((r) => {
                // Get wishlist items
                const isInWishlist = [...r].find((item) => item.empi === $self.state.product.id);

                if(isInWishlist) {
                    document.querySelector('#pdp-wishlist').textContent = 'Remove From Wishlist';
                }

                console.log('Wishlist Response', {r, isInWishlist});
                $self.state.wishlist_items = [...r];
                $self.state.in_wishlist = Boolean(isInWishlist);
            },
            );
        }

        window.SwymCallbacks.push(function(){
            wishlistStart();
        });
        

        function addToWishList(wishlistProduct) {
            

            window._swat.addToWishList(
                wishlistProduct,
                (r) => {
                  console.log('Added to wishlist', r);
                  document.querySelector('#pdp-wishlist').textContent = 'Remove From Wishlist';
                  $self.state.in_wishlist = true;
                }
            );
        }

        function removeFromWishlist(wishlistProduct) {
            window._swat.removeFromWishList(
              wishlistProduct,
              (r) => {
                console.log('Removed from wishlist');
                document.querySelector('#pdp-wishlist').textContent = 'Wishlist';
                $self.state.in_wishlist = false;
              }
            );
        }

        function clickHandler(event) {
            const $btn = event.target;
          const product = $self.state.product;

          const inventoryQty = [...product.variants].reduce((total, variant) => {
            return total + variant.inventory_quantity;
          }, 0);
          
          const variants = [...product.variants].map((variant) => {
            return {
              [variant.title] : variant.id
            }
          });       

          const wishlistProduct = {
            epi: product.variants[0].id,
            du: `https://jenmeyer.myshopify.com/products/${product.handle}`,
            empi: product.id,
            iu: product.images[0],
            pr: product.price,
            stk: inventoryQty,
            variants,
          };

          if($self.state.in_wishlist) {
            removeFromWishlist(wishlistProduct);
          } else {
            addToWishList(wishlistProduct);
          }


          console.log('wishlist', { product, inventoryQty, variants, wishlistProduct });

        }


        document.querySelector('#pdp-wishlist').addEventListener('click', clickHandler);

    },
    qtyHandlers() {
        console.log('Run Qty');
        const $btns = document.querySelectorAll('.qty-adjustor');

        function clickHandler(event) {
            event.preventDefault();
            const updateBy = (event.target.getAttribute('direction') === 'up') ? 1 : -1;
            const $qty = event.target.parentElement.querySelector('input');

            console.log('Click Qty');

            $qty.value = Math.max(parseInt($qty.value) + updateBy, 1);
        }

        [...$btns].forEach(($btn) => $btn.addEventListener('click', clickHandler));
    },
    start() {
        console.log('Start PDP');
        this.productJSON();
        // this.carousels();
        this.checkInfiniteOptions();
        this.checkAddons();
        this.nostoHandlers();
        this.descriptionHandler();
        this.otherColorsDetection();
        this.priceUponRequest();
        this.wishlistHandler();
        this.qtyHandlers();
    }
};

// PDP.start();

window.PDP = PDP;